import { Method } from '@rxap/utilities';
import { OpenApiMethod, HttpMethods, BaseOpenApiMethod } from '../../open-api.method';

@OpenApiMethod({
  method: HttpMethods.DELETE,
  apiName: 'customer',
  path: '/product/{productId}',
  operationId: 'ProductController_archiveById',
  parameters: [],
})
export class ProductControllerArchiveByIdMethod extends BaseOpenApiMethod<void> implements Method<void, void> {
  public call(): Promise<void> {
    return super.call();
  }
}
